import { useMutation } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { ICreateUploadQueueItemsRequest } from '../models/interfaces/ICreateUploadQueueItemsRequest';
import { SetupReprocessingParams } from '../models/interfaces/IQueueGroup';

export const useCreateUploadQueueItems = () => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    return useMutation<boolean, unknown, ICreateUploadQueueItemsRequest>(
        async (request) => {
            const response = await axios.post<IResponseAPI<boolean>>(
                `${tenantConfig?.endpoints.queue}/Queue/ItemQueue/CreateUploadQueueItems`,
                request,
                {
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};

export const useSetupReprocessing = () => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    return useMutation<boolean, unknown, SetupReprocessingParams>(
        async (request) => {
            const response = await axios.post<IResponseAPI<boolean>>(
                `${tenantConfig?.endpoints.queue}/Queue/ItemQueue/SetupReprocessing`,
                request,
                {
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};
